export class OptionsDTO {
  static init(value: string, title: string) {
    const entity = new OptionsDTO();
    entity.value = value;
    entity.title = title;
    return entity;
  }
  value = '';
  title = '';
}
